module.exports = __webpack_public_path__ + "images/google-plus.svg";


//////////////////
// WEBPACK FOOTER
// ./images/google-plus.svg
// module id = 22
// module chunks = 1